import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const NameFormat = (props) => {
  return (
    <FormGroup controlId="nameFormat">
      <Col componentClass={ControlLabel} sm={5}>
        Name Format
      </Col>
      <Col sm={7}>
            <select
              className="custom-select"
              name="nameFormat"
              value={props.nameFormat}
              onChange={props.handleChangeNameFormat}
              required={props.required}
              disabled={props.disabled}
            >
              <option value="">Please select</option>
              <option value="surnameGivenName">Surname – Given Name</option>
              <option value="givenNameSurname">Given Name - Surname</option>
            </select>
      </Col>
    </FormGroup>
  )
}

NameFormat.propTypes = {
  handleChangeNameFormat: PropTypes.func,
  nameFormat: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool
};

NameFormat.defaultProps = {
  disabled: false,
  required: false
};

export default NameFormat;



// WEBPACK FOOTER //
// ./src/app/components/nameFormat/NameFormat.js